import { z } from "zod";

const translationPath = "components.messages.errors.";

const evaluatiomFormSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "evaluation_form" },
);

const tasyScheduleRecordsSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const tasyScheduleClassificationsSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const ticketAutRoundSchedulesDateSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const appointmentArrivalRuleSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const esignRulesSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const scheduleReminderFilterTypeSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const tasyScheduleTypesSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const tasyHealthInsurancesSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const establishmentsSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const calendarPreferencesSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const tasyCalendarStatusesSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const tasyAuthStatusesSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const surgeryFilterSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const ticketAutomationSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().optional().nullable(),
    isSendFile: z.boolean(),
    allowTransfer: z.boolean(),
    allowForm: z.boolean(),
  },
  { invalid_type_error: translationPath + "ticket_automation" },
);

const ticketChannelStepWhenSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const ticketChannelWhenSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const activeServiceSearchSurveyTypeSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const missingStatusSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});
export const messageSchema = z
  .object({
    id: z.string().optional(),
    enable: z.boolean(),
    exception: z.boolean(),
    send: z.boolean(),
    name: z.string().min(1, translationPath + "name"),
    initialDate: z.date({
      invalid_type_error: translationPath + "initial_date",
    }),
    endDate: z.date({ invalid_type_error: translationPath + "end_date" }),
    evaluationForm: evaluatiomFormSchema.nullish(),
    ticketAutRoundSchedulesDate: ticketAutRoundSchedulesDateSchema.nullish(),
    appointmentArrivalRule: appointmentArrivalRuleSchema.nullish(),
    esignRules: z.array(esignRulesSchema).nullish(),
    scheduleReminderFilterType: scheduleReminderFilterTypeSchema.nullish(),
    ticketAutomation: ticketAutomationSchema.nullish(),
    activeServiceSearchSurveyType:
      activeServiceSearchSurveyTypeSchema.nullish(),
    tasyScheduleRecords: z.array(tasyScheduleRecordsSchema).optional(),
    tasyScheduleClassifications: z
      .array(tasyScheduleClassificationsSchema)
      .optional(),
    tasyScheduleTypes: z.array(tasyScheduleTypesSchema).optional(),
    tasyHealthInsurances: z.array(tasyHealthInsurancesSchema).optional(),
    establishments: z.array(establishmentsSchema).optional(),
    calendarPreferences: z.array(calendarPreferencesSchema).optional(),
    tasyAuthStatuses: z.array(tasyAuthStatusesSchema).optional(),
    tasyCalendarStatuses: z.array(tasyCalendarStatusesSchema).optional(),
    surgeryTypes: z.array(surgeryFilterSchema).optional(),
    surgeryPortes: z.array(surgeryFilterSchema).optional(),
    surgeryCareCharacters: z.array(surgeryFilterSchema).optional(),
    surgeryServiceSectors: z.array(surgeryFilterSchema).optional(),
    surgeryHealthInsurances: z.array(surgeryFilterSchema).optional(),
    moveTicket: z.boolean(),
    moveTicketCancel: z.boolean(),
    moveTicketNotMe: z.boolean(),
    moveTicketConfirm: z.boolean(),
    moveTicketAttendant: z.boolean(),
    isRequiredCancellation: z.boolean(),
    ticketChannelStepWhenNot: ticketChannelStepWhenSchema.nullish(),
    ticketChannelWhenNot: ticketChannelWhenSchema.nullish(),
    ticketChannelStepWhenCancel: ticketChannelStepWhenSchema.nullish(),
    ticketChannelWhenCancel: ticketChannelWhenSchema.nullish(),
    ticketChannelStepWhenNotMe: ticketChannelStepWhenSchema.nullish(),
    ticketChannelWhenNotMe: ticketChannelWhenSchema.nullish(),
    ticketChannelStepWhenConfirm: ticketChannelStepWhenSchema.nullish(),
    ticketChannelWhenConfirm: ticketChannelWhenSchema.nullish(),
    ticketChannelStepWhenAttendant: ticketChannelStepWhenSchema.nullish(),
    ticketChannelWhenAttendant: ticketChannelWhenSchema.nullish(),
    qtyPacientSent: z.string().nullish(),
    priority: z.string().nullish(),
    origin: z.string().nullish(),
    schedulingMethod: z.string().nullish(),
    serviceClassification: z.string().nullish(),
    serviceSector: z.string().nullish(),
    serviceType: z.string().nullish(),
    serviceComplaint: z.string().nullish(),
    groupingIdentifier: z.string().nullish(),
    integrationType: z.string().nullish(),
    sendToConfimed: z.boolean(),
    cancellationReasonCode: z.string().nullish(),
    cancellationReasonDescription: z.string().nullish(),
    examCancellationReasonCode: z.string().nullish(),
    examCancellationReasonDescription: z.string().nullish(),
    surgeryCancellationReasonCode: z.string().nullish(),
    surgeryCancellationReasonDescription: z.string().nullish(),
    calendarHistoryType: z.string().nullish(),
    internalProcedure: z.string().nullish(),
    individualIdentifier: z.string().nullish(),
    qtyMessageSendingAttempts: z.string().nullish(),
    confirmScheduleWithOk: z.boolean(),
    indicationSequence: z.string().nullish(),
    usePatientEncounterInfoPhone: z.boolean(),
    missingStatus: missingStatusSchema.nullish(),
  })
  .superRefine((val, ctx) => {
    if (val.ticketAutomation) {
      if (val.ticketAutomation.allowForm) {
        if (
          !val.activeServiceSearchSurveyType ||
          val.activeServiceSearchSurveyType?.code === "1"
        ) {
          if (!val.evaluationForm) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: translationPath + "evaluation_form",
              path: ["evaluationForm"],
            });
          }
        }
      }
    }
    if (val.initialDate > val.endDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "initial_date_bigger",
        path: ["initialDate"],
      });
    }
    if (val.initialDate > val.endDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "initial_date_bigger",
        path: ["initialDate"],
      });
    }
    if (val.exception === true) {
      if (
        (!val.establishments || val.establishments.length === 0) &&
        (!val.tasyHealthInsurances || val.tasyHealthInsurances.length === 0) &&
        (!val.tasyScheduleRecords || val.tasyScheduleRecords.length === 0) &&
        (!val.tasyScheduleClassifications ||
          val.tasyScheduleClassifications.length === 0) &&
        (!val.tasyScheduleTypes || val.tasyScheduleTypes.length === 0) &&
        (!val.origin || val.origin.length === 0) &&
        (!val.schedulingMethod || val.schedulingMethod.length === 0) &&
        (!val.serviceClassification ||
          val.serviceClassification.length === 0) &&
        (!val.serviceSector || val.serviceSector.length === 0) &&
        (!val.serviceType || val.serviceType.length === 0) &&
        (!val.serviceComplaint || val.serviceComplaint.length === 0) &&
        (!val.surgeryTypes || val.surgeryTypes.length === 0) &&
        (!val.surgeryPortes || val.surgeryPortes.length === 0) &&
        (!val.surgeryCareCharacters ||
          val.surgeryCareCharacters.length === 0) &&
        (!val.surgeryServiceSectors ||
          val.surgeryServiceSectors.length === 0) &&
        (!val.surgeryHealthInsurances ||
          val.surgeryHealthInsurances.length === 0) &&
        (!val.groupingIdentifier || val.groupingIdentifier.length === 0) &&
        (!val.integrationType || val.integrationType.length === 0) &&
        (!val.internalProcedure || val.internalProcedure.length === 0)
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "exception",
          path: ["exception"],
        });
      }
    }
    if (val.moveTicket) {
      if (!val.ticketChannelWhenNot) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "ticket_channel_when_not",
          path: ["ticketChannelWhenNot"],
        });
      }
      if (!val.ticketChannelStepWhenNot) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "ticket_channel_step_when_not",
          path: ["ticketChannelStepWhenNot"],
        });
      }
    }
    if (val.moveTicketCancel) {
      if (!val.ticketChannelWhenCancel) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "ticket_channel_when_cancel",
          path: ["ticketChannelWhenCancel"],
        });
      }
      if (!val.ticketChannelStepWhenCancel) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "ticket_channel_step_when_cancel",
          path: ["ticketChannelStepWhenCancel"],
        });
      }
    }
    if (val.moveTicketNotMe) {
      if (!val.ticketChannelWhenNotMe) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "ticket_channel_when_not_me",
          path: ["ticketChannelWhenNotMe"],
        });
      }
      if (!val.ticketChannelStepWhenNotMe) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "ticket_channel_step_when_not_me",
          path: ["ticketChannelStepWhenNotMe"],
        });
      }
    }
    if (val.moveTicketConfirm) {
      if (!val.ticketChannelWhenConfirm) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "ticket_channel_when_confirm",
          path: ["ticketChannelWhenConfirm"],
        });
      }
      if (!val.ticketChannelStepWhenConfirm) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "ticket_channel_step_when_confirm",
          path: ["ticketChannelStepWhenConfirm"],
        });
      }
    }
    if (val.moveTicketAttendant) {
      if (!val.ticketChannelWhenAttendant) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "ticket_channel_when_attendant",
          path: ["ticketChannelWhenAttendant"],
        });
      }
      if (!val.ticketChannelStepWhenAttendant) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "ticket_channel_step_when_attendant",
          path: ["ticketChannelStepWhenAttendant"],
        });
      }
    }
    if (val.ticketAutomation) {
      if (
        (val.ticketAutomation.code === "9" ||
          val.ticketAutomation.code === "10") &&
        (!val.qtyPacientSent || val.qtyPacientSent?.length === 0)
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "qty_pacient_sent",
          path: ["qtyPacientSent"],
        });
      }
      if (
        val.ticketAutomation.code === "22" &&
        (!val.calendarHistoryType || val.calendarHistoryType?.length === 0)
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "calendarHistoryType",
          path: ["calendarHistoryType"],
        });
      }
      if (
        ["27", "35"].includes(val.ticketAutomation.code ?? "") &&
        !val.activeServiceSearchSurveyType
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "active_service_search_survey_type",
          path: ["activeServiceSearchSurveyType"],
        });
      }
    }
    if (val.isRequiredCancellation && !val.exception) {
      if (
        !val.cancellationReasonCode &&
        val.ticketAutomation?.code &&
        ["1", "11", "12", "16", "18"].includes(val.ticketAutomation.code)
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "cancellationReasonCode",
          path: ["cancellationReasonCode"],
        });
      }
      if (
        !val.cancellationReasonDescription &&
        val.ticketAutomation?.code &&
        ["1", "11", "12", "16", "18"].includes(val.ticketAutomation.code) &&
        !val.cancellationReasonCode?.includes(",")
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "cancellationReasonDescription",
          path: ["cancellationReasonDescription"],
        });
      }
      if (
        !val.examCancellationReasonCode &&
        val.ticketAutomation?.code &&
        ["5", "11", "13", "17", "18"].includes(val.ticketAutomation.code)
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "examCancellationReasonCode",
          path: ["examCancellationReasonCode"],
        });
      }
      if (
        !val.examCancellationReasonDescription &&
        val.ticketAutomation?.code &&
        ["5", "11", "13", "17", "18"].includes(val.ticketAutomation.code) &&
        !val.examCancellationReasonCode?.includes(",")
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "examCancellationReasonDescription",
          path: ["examCancellationReasonDescription"],
        });
      }
      if (
        !val.surgeryCancellationReasonCode &&
        val.ticketAutomation?.code &&
        ["34"].includes(val.ticketAutomation.code)
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "surgeryCancellationReasonCode",
          path: ["surgeryCancellationReasonCode"],
        });
      }
      if (
        !val.surgeryCancellationReasonDescription &&
        val.ticketAutomation?.code &&
        ["34"].includes(val.ticketAutomation.code) &&
        !val.surgeryCancellationReasonCode?.includes(",")
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "surgeryCancellationReasonDescription",
          path: ["surgeryCancellationReasonDescription"],
        });
      }
    }
  });

export type TMessageForm = z.infer<typeof messageSchema>;
